/**
 * Node Modules
 */
import React, {createElement} from 'react'
import marksy from 'marksy/jsx'

/**
 * Application Modules
 */
import './style.css'
import '../../../components/styles/buttons.css'
import Section from '../../../components/section'
import Header from '../../../components/header'
import Spacer from '../../../components/spacer'

import DownloadButtons from '../../../components/download-icons'

const compile = marksy({createElement})

/**
 * Component
 */
export default function EarlyAccess({ hed, dek, download = false, ios = false, android = false }) {

  console.log(compile(`Create memories, <br/> share experiences`), {breaks: true})

  return (
    <Section className="early-access">
      <Header
        styles={{
          '--logo-color': 'var(--white)',
          '--color': 'var(--white)',
          '--active-color': 'var(--coral)',
          '--background-color': 'var(--light-purple)',
        }}
      />
      <div className="early-access__grid grid">
        <div className="column-start-1 column-start-2--d column-end-6 column-end-7--t">
          <div className="early-access__hed text-center ">{compile(hed, {breaks: true}).tree}</div>
          <Spacer size={[20,24]} />
          <div className="early-access__dek text-center">{compile(dek, {breaks: true}).tree}</div>
          <div className="early-access__fieldset">

            {
              download !== false ? (
                <>
                  <Spacer size={[30,45]} />
                  <div className={`flex flex-center flex-left--t`}>
                    <a className="button button--coral" href={download} target="_blank">
                      Download
                    </a>
                  </div>
                </>
              ) : (
                <>
                  <Spacer size={[30,90]} />
                  <DownloadButtons ios={ios} android={android} className={`flex-center`} />
                </>
              )
            }
            <Spacer size={[45,0]} />
          </div>
        </div>

        <div className="early-access__image-group column-start-1 column-end-6 column-start-8--t column-end-12--t flex flex-center">
          <div className="home-walk-through__frame">
            <img className="home-walk-through__video-frame" src="/home/phone-frame.png" />
            <video width="533" height="1152" className="home-walk-through__video" poster="/home/product-demo-poster.jpg" playsInline autoPlay loop muted>
              <source src="/home/product-demo.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </Section>
  )
}
